/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEducationFilter } from 'interface/education-content';
import type { TRootState } from './store';

type TEducationContentState = {
  page: number | undefined;
  perPage: number | undefined;
  filter?: any;
};

const slice = createSlice({
  name: 'educationContent',
  initialState: { page: 1, perPage: 10, filter: '' } as TEducationContentState,
  reducers: {
    setPaginationData: (
      state,
      {
        payload: { page, perPage },
      }: PayloadAction<{
        page: number | undefined;
        perPage: number | undefined;
      }>,
    ) => {
      state.page = page;
      state.perPage = perPage;
    },
    setEducationContentFilter: (state, { payload: filter }: PayloadAction<IEducationFilter>) => {
      let filterData: string = '';
      if (filter?.sortBy) filterData += `&sortBy=${filter.sortBy}`;
      if (filter?.sortOrder) filterData += `&sortOrder=${filter.sortOrder}`;
      if (filter?.tags) filterData += `&tags=${filter.tags.join(',')}`;
      if (filter?.q) filterData += `&q=${filter.q}`;
      state.filter = filterData;
      state.page = 1;
    },
  },
});

export const { setPaginationData, setEducationContentFilter } = slice.actions;

export default slice.reducer;

export const selectCurrentPage = (state: TRootState) => state.educationContent.page;
export const selectPageSize = (state: TRootState) => state.educationContent.perPage;
export const selectFilter = (state: TRootState) => state.educationContent.filter;
